import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { TextField, Checkbox, Button, Typography, Radio, FormControlLabel, FormControl, RadioGroup, InputLabel, Select, Snackbar } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { OfflineService } from "../../offline/storageService/offlineService";
import { SaveVisitationEVSOfflineData } from "../../offline/dataService/visitationEVSOfflineData";
import { SaveRecoveryEVSOfflineData } from "../../offline/dataService/recoveryEVSOfflineData";
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext.js';
import { Theme } from '../contexts/themeContext.js';
import { AssignedToUsers } from '../contexts/assignedToUsers.js';
import { TransactionTime } from '../common/transactionTime';
import InactiveTimeout from '../common/inactiveTimeout';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

//function RecoveryEVSAdd(props, ref) {
const RecoveryEVSAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const appVisitationTypes = props.appVisitationTypes;
    const visitDate = props.visitDate;
    const location = props.location;
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const [visitationRecovery, setVisitationRecovery] = useState([]);
    const [recoveries, setRecoveries] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [defaultAssignedTo, setDefaultAssignedTo] = useState([]);
    const [resolved, setResolved] = useState(false);
    const [tempateLoaded, setTemplateLoaded] = useState(false);
    const [answersLoaded, setAnswerslLoaded] = useState(false);
    const [addRecovery, setAddRecovery] = useState(false);
    const [showInactiveMessage, setShowInactiveMessage] = useState(false);
    const [reflect, setReflect] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    useImperativeHandle(ref, () => {
        return {
            save: modified ? saveRecovery : props.parentCallback
            , valueChanged: valueChanged
        };
    });

    const valueChanged = () => {
        setModified(true);
    }

    const cancel = () => {
        props.parentCallback();
    }

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const issueTypeChanged = (event, id) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
        templates[index].IssueTypeId = parseInt(event.target.value);
        setTemplates(templates);
        setModified(true);
        props.inputValueChanged();
        setReflect(!reflect);
    };

    const priorityTypeChanged = (event, id) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
        templates[index].PriorityId = parseInt(event.target.value);
        setTemplates(templates);
        setModified(true);
        props.inputValueChanged();
        setReflect(!reflect);
    };

    const dueDateChanged = (date, id) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
        templates[index].DueDate = (date === null ? null : moment(date).format("MM/DD/YYYY"));
        setTemplates(templates);
        setModified(true);
        setReflect(!reflect);
    };

    const resolvedChanged = (event, id) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
        templates[index].Resolved = event.target.checked;
        setTemplates(templates);
        setModified(true);
        props.inputValueChanged();
        setReflect(!reflect);
    };

    const resolutionChanged = (event, id) => {
        var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
        templates[index].Resolution = event.target.value;
        setTemplates(templates);
        setModified(true);
        props.inputValueChanged();
        setReflect(!reflect);
    };

    const commentsChanged = (event, id) => {
        var output = templates.filter(x => x.AppVisitationTemplateId === id);
        if (output.length > 0) {
            var index = templates.findIndex(x => x.AppVisitationTemplateId === id);
            templates[index].Comments = event.target.value;
            setTemplates(templates);
            setModified(true);
            props.inputValueChanged();
            setReflect(!reflect);
        }
    };

    const userSelected = (event, values, id) => {
        var ids = "", names = "";

        for (var index = 0; index < values.length; index++) {
            ids += values[index].id + ",";
            names += values[index].firstName + " " + values[index].lastName + ",";
        }

        if (props.visitation !== null) {
            var itemIndex = templates.findIndex(x => x.AppVisitationTemplateId === id);
            templates[itemIndex].DefaultAssignedTo = values;
            templates[itemIndex].AssignedToIds = ids?.substring(0, ids.length - 1);
            templates[itemIndex].AssignedToNames = names?.substring(0, names.length - 1);
            setTemplates(templates);
            setReflect(!reflect);
        }
        else {
            setVisitationRecovery({ ...visitationRecovery, AssignedToIds: ids?.substring(0, ids.length - 1), AssignedToNames: names?.substring(0, names.length - 1) });
            setDefaultAssignedTo(values);
        }
        setModified(true);
        props.inputValueChanged();
    };

    const getAppVisitationTemplates = () => {
        HttpService.post('/VisitationEVS/GetAppVisitationTemplates')
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationTemplates");
                result.data = offlineResult.OfflineData.data;
            }
            setTemplates(result.data);
            setTemplateLoaded(true);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationAnswers = (appVisitationId) => {
        HttpService.post('/VisitationEVS/GetAppVisitationAnswers', { AppVisitation: appVisitationId })
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                if ((appVisitationId + "").substr(0, 1) === "$") {
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitations");
                    const data = offlineResult.OfflineData.data;
                    result.data = data.filter(d => d.AppVisitationId === appVisitationId)[0].answers;
                }
                else {
                    const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationAnswers");
                    let allAnswers = offlineResult.OfflineData;
                    result.data = allAnswers.filter(x => x.AppVisitation === appVisitationId);
                }
            }
            manipulateAnswers(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const manipulateAnswers = (data) => {
        setAddRecovery(false);
        let recoveryTemplates = [];
        let visitation = props.visitation;
        let list = templates.filter(x => x.IsAutoRecoveryCreation === true);

        list.forEach(function (item) {
            var index = data.findIndex(x => x.AppVisitationTemplateId === item.AppVisitationTemplateId && ((x.AppVisitationTypeId === 34 && x.AppVisitationTemplateId === 5) || (x.AppVisitationTypeId === 33 && x.AppVisitationTemplateId === 13)));
            var recoveryIndex = recoveries.findIndex(x => x.AppVisitationTemplateId === item.AppVisitationTemplateId);

            if (index !== -1 && recoveryIndex === -1) {
                setShowInactiveMessage(true);
                TransactionTime.begin('RecoveryEVS');
                item.AppVisitationRecoveryId = 0;
                item.AppVisitation = visitation.AppVisitationId;
                item.SiteId = visitation.SiteId;
                item.GeoLocation = visitation.GeoLocation;
                item.GeoLocationAncestor = visitation.GeoLocationAncestor;
                item.GeoLocationName = visitation.GeoLocationName;
                item.VisitDate = visitation.VisitDate;
                item.AppVisitationTemplateId = data[index].AppVisitationTemplateId;
                item.Comments = data[index].Comments;
                item.AssignedToIds = data[index].CoachPerformersId;
                item.AssignedToNames = data[index].CoachPerformersName;
                item.IssueTypeId = 0;
                item.PriorityId = 0;
                item.DueDate = null;
                item.Resolved = false;
                item.Resolution = null;
                recoveries.push(item);
            }
            else if (index === -1 && recoveryIndex !== -1) {
                recoveries.splice(recoveryIndex, 1);
            }
        });

        recoveries.forEach(function (item) {
            var index = templates.findIndex(x => x.AppVisitationTemplateId === item.AppVisitationTemplateId);
            var answerIndex = data.findIndex(x => x.AppVisitationTemplateId === item.AppVisitationTemplateId);

            if (index >= 0 && answerIndex >= 0) {
                templates[index].AppVisitation = item.AppVisitation;
                templates[index].SiteId = item.SiteId;
                templates[index].GeoLocation = item.GeoLocation;
                templates[index].GeoLocationAncestor = item.GeoLocationAncestor;
                templates[index].GeoLocationName = item.GeoLocationName;
                templates[index].VisitDate = visitation.VisitDate;
                templates[index].AppVisitationRecoveryId = item.AppVisitationRecoveryId;
                templates[index].AppVisitationTypeId = data[answerIndex].AppVisitationTypeId;
                templates[index].Comments = data[answerIndex].Comments;
                templates[index].IssueTypeId = item.IssueTypeId;
                templates[index].PriorityId = item.PriorityId;
                templates[index].DueDate = item.DueDate;
                templates[index].Resolved = item.Resolved;
                templates[index].Resolution = item.Resolution;
                templates[index].AssignedToIds = item.AssignedToIds;
                templates[index].AssignedToNames = item.AssignedToNames;
                let userIndex = -1;
                let array = [];
                if (item.AssignedToIds?.indexOf(',') > -1) {
                    let ids = item.AssignedToIds.split(',');
                    ids.forEach(function (id) {
                        userIndex = assignedUsers.findIndex(x => x.id === parseInt(id));
                        array.push(assignedUsers[userIndex]);
                    });
                }
                else {
                    userIndex = assignedUsers.findIndex(x => x.id === parseInt(item.AssignedToIds));
                    if (userIndex > -1)
                        array.push(assignedUsers[userIndex]);
                }
                templates[index].DefaultAssignedTo = array;
                recoveryTemplates.push(templates[index]);
            }
        });

        setTemplates(recoveryTemplates);
        setAnswerslLoaded(true);
    };

    const validate = () => {
        if (!location[0]?.id) {
            setErrorMessage("Please select a Location");
            return false;
        }

        if (props.visitation === null) {
            if (visitationRecovery.IssueTypeId === undefined || visitationRecovery.IssueTypeId === 0) {
                setErrorMessage("Please select an Issue Type");
                return false;
            }
            else if (visitationRecovery.Comments === undefined || visitationRecovery.Comments === "") {
                setErrorMessage("Please enter Comments");
                return false;
            }
            else if (visitationRecovery.AssignedToIds === undefined || visitationRecovery.AssignedToIds === "") {
                setErrorMessage("Please select the Assigned Users");
                return false;
            }
            else if (visitationRecovery.PriorityId === undefined || visitationRecovery.PriorityId === 0) {
                setErrorMessage("Please select a Priority");
                return false;
            }
            else if (visitationRecovery.DueDate === "Invalid date") {
                setErrorMessage("Please select the valid Due Date");
                return false;
            }
            else if (resolved && (visitationRecovery.Resolution === undefined || visitationRecovery.Resolution === null || visitationRecovery.Resolution === "")) {
                setErrorMessage("Please enter the Resolution");
                return false;
            }
        }
        else {
            for (var index = 0; index < templates.length; index++) {
                var item = templates[index];
                var message = ' for the question. "' + item.Description + '"';
                if (item.IssueTypeId === 0) {
                    setErrorMessage("Please select an Issue Type" + message);
                    return false;
                }
                else if (item.Comments === "") {
                    setErrorMessage("Please enter Comments" + message);
                    return false;
                }
                else if (item.AppVisitationTemplateId === 5 && (item.AssignedToIds === undefined || item.AssignedToIds === null || item.AssignedToIds === "")) {
                    setErrorMessage("Please select the Assigned Users" + message);
                    return false;
                }
                else if (item.PriorityId === 0) {
                    setErrorMessage("Please select a Priority" + message);
                    return false;
                }
                else if (item.DueDate === "Invalid date") {
                    setErrorMessage("Please select the valid Due Date" + message);
                    return false;
                }
                else if (item.Resolved && (item.Resolution === null || item.Resolution === "")) {
                    setErrorMessage("Please enter the Resolution" + message);
                    return false;
                }
            }
        }
        return true;
    };

    const saveRecovery = (e) => {
        var model = [];
        var valid = validate();

        if (!valid) {
            setOpenError(true);
            return;
        }
        else {
            setBackDrop(true);

            if (props.visitation === null) {
                model = visitationRecovery;
                model.Resolved = resolved;
                if (addRecovery) {
                    model.AppVisitationRecoveryId = 0;
                    model.SiteId = defaultSite.id;
                    model.GeoLocation = location[0].id;
                    model.GeoLocationAncestor = location[0].aid;
                    model.VisitDate = visitDate;
                    TransactionTime.end();
                    TransactionTime.updateData(model);
                }
                if (resolved) {
                    model.ResolvedDate = model.ResolvedDateString ? model.ResolvedDateString : ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite);
                }
                else {
                    model.ResolvedDate = null;
                }

                HttpService.post('/RecoveryEVS/SaveAppVisitationRecovery', model)
                .then(async result => {
                    if (result && result.offline) {
                        model.VisitDateString = model.VisitDate;
                        var indexedDBId = await SaveRecoveryEVSOfflineData(defaultSite.id, model.AppVisitationRecoveryId, "SaveAppVisitationRecovery", model, "/RecoveryEVS/SaveAppVisitationRecovery", false, false);
                        if (model.AppVisitationRecoveryId === 0)
                            model.AppVisitationRecoveryId = "$" + indexedDBId;
                        props.refreshGrid(model);
                    }
                    else {
                        await SaveRecoveryEVSOfflineData(defaultSite.id, model.AppVisitationRecoveryId, "SaveAppVisitationRecovery", result.data, "/RecoveryEVS/SaveAppVisitationRecovery", true, false);
                        props.refreshGrid(result.data);
                    }
                    setBackDrop(false);
                    props.parentCallback();
                },
                (error) => {
                    console.log(error);
                });
            }
            else {
                if (showInactiveMessage) {
                    TransactionTime.end();
                }
                for (var index = 0; index < templates.length; index++) {
                    let currentIndex = index;
                    let model = templates[index];
                    if (model.Resolved) {
                        model.ResolvedDate = model.ResolvedDateString ? model.ResolvedDateString : ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite);
                    }
                    else {
                        model.ResolvedDate = null;
                    }
                    if (model.AppVisitationRecoveryId === 0) {
                        TransactionTime.updateData(model);
                    }
                    HttpService.post('/RecoveryEVS/SaveAppVisitationRecovery', model)
                    .then(async result => {
                        if (result && result.offline) {
                            let temp = [];
                            const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitations");
                            const data = offlineResult.OfflineData.data;
                            const index = data.findIndex(d => d.AppVisitationId === model.AppVisitation);
                            temp = data[index];
                            temp.recoveries = templates;
                            await SaveVisitationEVSOfflineData(defaultSite.id, temp.AppVisitationId, "SaveAppVisitation", temp, "/VisitationEVS/SaveAppVisitation", false, false);
                        }
                        else {
                            await SaveRecoveryEVSOfflineData(defaultSite.id, result.data.AppVisitationRecoveryId, "SaveAppVisitationRecovery", result.data, "/RecoveryEVS/SaveAppVisitationRecovery", true, false);
                        }

                        if (currentIndex === templates.length - 1) {
                            setBackDrop(false);
                            props.parentCallback();
                        }
                    },
                    (error) => {
                        console.log(error);
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (assignedUsers.length === 0 || assignedUsers[0].uniBrief !== defaultSite.houseCode.toString()) {
            getAssignedToUsers();
        }

        if (props.visitation !== null) {
            setRecoveries(props.recoveries);
            getAppVisitationTemplates();
        }
        else if (props.model.length === 0) {
            visitationRecovery.DueDate = null;
            setAddRecovery(true);
            setShowInactiveMessage(true);
            TransactionTime.begin('RecoveryEVS');
            setBackDrop(false);
        }
        else {
            setVisitationRecovery(props.model);
            setResolved(props.model.Resolved);
            setBackDrop(false);
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (tempateLoaded) {
            getAppVisitationAnswers(props.visitation.AppVisitationId);
        }
        // eslint-disable-next-line 
    }, [tempateLoaded]);

    useEffect(() => {
        if (assignedUsers.length > 0) {
            let userIndex = -1;
            let array = [];
            if (props.model.AssignedToIds?.indexOf(',') > -1) {
                let ids = props.model.AssignedToIds.split(',');
                ids.forEach(function (id) {
                    userIndex = assignedUsers.findIndex(x => x.id === parseInt(id));
                    array.push(assignedUsers[userIndex]);
                });
            }
            else {
                userIndex = assignedUsers.findIndex(x => x.id === parseInt(props.model.AssignedToIds));
                if (userIndex > -1)
                    array.push(assignedUsers[userIndex]);
            }

            setDefaultAssignedTo(array);
        }
    }, [assignedUsers, props.model.AssignedToIds]);

    return (<>
        <Backdrop className={classes.backdrop} id="addRecoveryBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
            <Alert onClose={closeErrorSnackbar} severity="error">
                {errorMessage}
            </Alert>
        </Snackbar>
        <div className={classes.root} autoComplete="off">
            <ValidatorForm className={classes.root} autoComplete="off" onSubmit={saveRecovery} reflectchanges={reflect.toString()}>
                {answersLoaded && templates.length > 0 && templates.map((template, key) => {
                    return (<div key={template.AppVisitationTemplateId}>
                        <Typography variant="subtitle1" style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>
                            {template.Description}
                        </Typography>
                        {template.AppVisitationTemplateId === 13 &&
                            <div>
                                {
                                    appVisitationTypes.followUps.map((option, key) => {
                                        return (<Typography key={option.AppVisitationTypeId} variant="subtitle1"
                                            style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>
                                            * {option.Title}
                                        </Typography>
                                        )
                                    })
                                }
                            </div>
                        }
                        {template.QuestionType === 'YesNo' &&
                            (<>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="yesNo" name="yesNo" style={{ display: 'block' }} value={template.AppVisitationTypeId || ''}>
                                        {appVisitationTypes.yesNo.map((option, key) => {
                                            return (
                                                <FormControlLabel value={option.AppVisitationTypeId} key={option.AppVisitationTypeId}
                                                    id={`radio${template.AppVisitationTemplateId}_${option.Title}`}
                                                    control={<Radio disabled checked={template.AppVisitationTypeId === option.AppVisitationTypeId} style={{ color: currentTheme.secondary }} />}
                                                    label={option.Title} style={{ color: currentTheme.text }} />
                                            )
                                        })
                                        }
                                    </RadioGroup>
                                </FormControl>
                                <FormControl variant="outlined" margin="dense" className={classes.ddl} fullWidth>
                                    <InputLabel htmlFor="IssueType">Issue Type</InputLabel>
                                    <Select
                                        native
                                        label="Issue Type"
                                        size="small"
                                        value={template.IssueTypeId}
                                        onChange={(e) => issueTypeChanged(e, template.AppVisitationTemplateId)}
                                    >
                                        <option aria-label="None" key="0" value="0" />
                                        {
                                        appVisitationTypes.issueTypes.map((option, key) => {
                                            return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                <br /> <br />
                                <TextField size="small" fullWidth
                                    label="Comments"
                                    variant="outlined"
                                    value={template.Comments || ""}
                                    onChange={e => commentsChanged(e, template.AppVisitationTemplateId)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <br /> <br />
                                <Autocomplete
                                    size="small"
                                    id={"AssignedTo" + template.AppVisitationTemplateId}
                                    multiple
                                    disablePortal={true}
                                    filterSelectedOptions
                                    options={assignedUsers}
                                    getOptionLabel={(option) => `${option?.firstName} ${option?.lastName}`}
                                    value={template.DefaultAssignedTo}
                                    onChange={(e, v) => userSelected(e, v, template.AppVisitationTemplateId)}
                                    disabled={template.AppVisitationTemplateId === 13}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label="Assigned To"
                                                placeholder="Assigned Users"
                                            />
                                        )}
                                />
                                <br />
                                <FormControl variant="outlined" margin="dense" className={classes.ddl} fullWidth>
                                    <InputLabel htmlFor="Priority">Priority</InputLabel>
                                    <Select
                                        native
                                        label="Priority"
                                        size="small"
                                        value={template.PriorityId}
                                        onChange={(e) => priorityTypeChanged(e, template.AppVisitationTemplateId)}
                                    >
                                        <option aria-label="None" key="0" value="0" />
                                        {
                                            appVisitationTypes.priorityTypes.map((option, key) => {
                                                return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                <br />
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        fullWidth
                                        disableToolbar
                                        autoOk
                                        id="DueDate"
                                        label="Due Date"
                                        format="MM/dd/yyyy"
                                        value={template.DueDate}
                                        onChange={(date) => dueDateChanged(date, template.AppVisitationTemplateId)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        margin="normal"
                                        size="small"
                                        InputAdornmentProps={{ position: "start" }}
                                        variant="inline"
                                        inputVariant="outlined"
                                        PopoverProps={{
                                            anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                            transformOrigin: { horizontal: "left", vertical: "top" }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                                <br />
                                <FormControlLabel
                                    style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                    value="end"
                                    label="Resolved"
                                    labelPlacement="end"
                                    control={<Checkbox color="primary" checked={template.Resolved} />}
                                    onChange={(e) => resolvedChanged(e, template.AppVisitationTemplateId)}
                                />
                                <br /><br />
                                {template.Resolved &&
                                    <TextField fullWidth
                                        id={"Resolution"+ template.AppVisitationTemplateId}
                                        label="Resolution"
                                        placeholder="Resolution "
                                        multiline
                                        rows="4"
                                        variant="outlined"
                                        value={template.Resolution || ""}
                                        onChange={(e) => resolutionChanged(e, template.AppVisitationTemplateId)}
                                        style={{ width: "100%" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                }
                            </>
                            )}
                    </div>
                    )
                })
                }
                {!answersLoaded && <>
                <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                    <InputLabel htmlFor="IssueType">Issue Type</InputLabel>
                    <Select
                        native
                        label="Issue Type"
                        size="small"
                        value={visitationRecovery.IssueTypeId}
                        onChange={(e) => {
                            setVisitationRecovery({ ...visitationRecovery, IssueTypeId: parseInt(e.target.value) });
                            setModified(true);
                            props.inputValueChanged();
                        }}
                    >
                        <option aria-label="None" key="0" value="0" />
                        {
                            appVisitationTypes.issueTypes.map((option, key) => {
                                return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                            })
                        }
                    </Select>
                </FormControl>
                <TextField size="small" fullWidth
                    label="Comments"
                    variant="outlined"
                    value={visitationRecovery.Comments || ""}
                    onChange={(e) => {
                        setVisitationRecovery({ ...visitationRecovery, Comments: e.target.value });
                        setModified(true);
                        props.inputValueChanged();
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <Autocomplete
                    multiple
                    disablePortal={true}
                    size="small"
                    id="AssignedTo"
                    options={assignedUsers}
                    getOptionLabel={(option) => `${option?.firstName} ${option?.lastName}`}
                    value={defaultAssignedTo}
                    filterSelectedOptions
                    onChange={(e, v) => userSelected(e, v, 13)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Assigned To"
                            placeholder="Assigned Users"
                        />
                    )}
                />
                <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                    <InputLabel htmlFor="Priority">Priority</InputLabel>
                    <Select
                        native
                        label="Priority"
                        size="small"
                        value={visitationRecovery.PriorityId}
                        onChange={(e) => {
                            setVisitationRecovery({ ...visitationRecovery, PriorityId: parseInt(e.target.value) });
                            setModified(true);
                            props.inputValueChanged();
                        }}
                    >
                        <option aria-label="None" key="0" value="0" />
                        {
                            appVisitationTypes.priorityTypes.map((option, key) => {
                                return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                            })
                        }
                    </Select>
                </FormControl>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        autoOk
                        id="DueDate"
                        label="Due Date"
                        format="MM/dd/yyyy"
                        value={visitationRecovery.DueDate}
                        onChange={(date) => {
                            setVisitationRecovery({ ...visitationRecovery, DueDate: (date === null ? null : moment(date).format("MM/DD/YYYY")) });
                            setModified(true);
                            props.inputValueChanged();
                        }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        margin="normal"
                        size="small"
                        InputAdornmentProps={{ position: "start" }}
                        variant="inline"
                        inputVariant="outlined"
                        PopoverProps={{
                            anchorOrigin: { horizontal: "left", vertical: "bottom" },
                            transformOrigin: { horizontal: "left", vertical: "top" }
                        }}
                    />
                </MuiPickersUtilsProvider>
                <FormControlLabel
                    style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                    value="end"
                    label="Resolved"
                    labelPlacement="end"
                    control={<Checkbox color="primary" checked={resolved} onChange={(e) => { setResolved(e.target.checked); setModified(true); props.inputValueChanged(); }} />}
                 />
                {resolved &&
                    <TextField fullWidth
                        id="Resolution"
                        label="Resolution"
                        placeholder="Resolution "
                        multiline
                        rows="4"
                        variant="outlined"
                        value={visitationRecovery.Resolution || ""}
                        onChange={(e) => {
                            setVisitationRecovery({ ...visitationRecovery, Resolution: e.target.value });
                            setModified(true);
                            props.inputValueChanged();
                        }}
                        style={{ width: "100%" }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                }
                </>
                }
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                    style={{ background: currentTheme.secondary, width: "100px" }}
                    startIcon={<SaveIcon />}
                    type="submit"
                    onSubmit={saveRecovery}
                >
                    Save
                </Button>
            </ValidatorForm>
        </div>
        {(showInactiveMessage) && (
            <InactiveTimeout disContinue={cancel} />
        )}
    </>
    );
});
//export default forwardRef(RecoveryEVSAdd);
export default RecoveryEVSAdd;
